function Consumer(email1, email2, billingAddress, shippingAddress, account) {
	this.Email1 = email1;
	this.Email2 = email2;
	this.BillingAddress = billingAddress;
	this.ShippingAddress = shippingAddress;
	this.Account = account;
}

module.exports = Consumer;


//////////////////
// WEBPACK FOOTER
// ./models/consumer.js
// module id = 46
// module chunks = 0 5 20